/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Findprospectsfromsalesforce4Inputs */

const en_coinvestments_findprospectsfromsalesforce4 = /** @type {(inputs: Coinvestments_Findprospectsfromsalesforce4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Prospects`)
};

/**
* | output |
* | --- |
* | "Import Prospects" |
*
* @param {Coinvestments_Findprospectsfromsalesforce4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_findprospectsfromsalesforce4 = /** @type {((inputs?: Coinvestments_Findprospectsfromsalesforce4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Findprospectsfromsalesforce4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_findprospectsfromsalesforce4(inputs)
});
export { coinvestments_findprospectsfromsalesforce4 as "coInvestments_findProspectsFromSalesforce" }